import { render, staticRenderFns } from "./NrlAccLogin.vue?vue&type=template&id=70116937&scoped=true"
import script from "./NrlAccLogin.vue?vue&type=script&lang=js"
export * from "./NrlAccLogin.vue?vue&type=script&lang=js"
import style0 from "./NrlAccLogin.vue?vue&type=style&index=0&id=70116937&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70116937",
  null
  
)

export default component.exports